/**
 * @generated SignedSource<<cc1e38b9c0b034d673980ccb84989f60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CoverImageKind = "UPLOAD" | "URL" | "%future added value";
export type SpacesCreateShortcutMutationInput = {
  clientMutationId?: string | null;
  coverImage: CoverImageInput;
  spaceId: string;
  title: string;
  url: string;
};
export type CoverImageInput = {
  kind: CoverImageKind;
  value: string;
};
export type ManageSpaceShortcutModal_createSpaceShortcut_Mutation$variables = {
  input: SpacesCreateShortcutMutationInput;
};
export type ManageSpaceShortcutModal_createSpaceShortcut_Mutation$data = {
  readonly createSpaceShortcut: {
    readonly space: {
      readonly id: string;
      readonly shortcuts: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly coverImage: {
              readonly name: string | null;
              readonly url: URIString;
            };
            readonly id: string;
            readonly title: string;
            readonly url: URIString;
          } | null;
        }>;
      } | null;
    };
  } | null;
};
export type ManageSpaceShortcutModal_createSpaceShortcut_Mutation = {
  response: ManageSpaceShortcutModal_createSpaceShortcut_Mutation$data;
  variables: ManageSpaceShortcutModal_createSpaceShortcut_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SpacesCreateShortcutMutationPayload",
    "kind": "LinkedField",
    "name": "createSpaceShortcut",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SpaceShortcutConnection",
            "kind": "LinkedField",
            "name": "shortcuts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SpaceShortcutEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SpaceShortcut",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CoverImage",
                        "kind": "LinkedField",
                        "name": "coverImage",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ManageSpaceShortcutModal_createSpaceShortcut_Mutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ManageSpaceShortcutModal_createSpaceShortcut_Mutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "a085d4fcd16d96231f0bccb6c2258bca",
    "id": null,
    "metadata": {},
    "name": "ManageSpaceShortcutModal_createSpaceShortcut_Mutation",
    "operationKind": "mutation",
    "text": "mutation ManageSpaceShortcutModal_createSpaceShortcut_Mutation(\n  $input: SpacesCreateShortcutMutationInput!\n) {\n  createSpaceShortcut(input: $input) {\n    space {\n      id\n      shortcuts {\n        edges {\n          node {\n            id\n            title\n            url\n            coverImage {\n              name\n              url\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b7dce23cb89f5edece63f50412cbd659";

export default node;
